import { Injectable } from '@angular/core';

//factory
import { createChild, createParent } from '../../factory/tree-node-factory';

//model
import { TreeNode } from '../../models/interfaces/tree-node.interface';

//Services
import { TreeService } from './tree.service';
import { ProfileService } from '../profile.service';
import { Observable } from 'rxjs';

@Injectable()
export class TreeProfilesService extends TreeService {
  constructor(
    private readonly profilesService: ProfileService,
  ) {
    super();
  }

  createTreeProfiles(
    idsProfiles: string[] | undefined,
    parentName? : string
  ): Observable<TreeNode> {
    return new Observable(subscriber => {
      this.profilesService.getAll()
        .subscribe(profiles => {
          if (profiles && profiles.length > 0) {
            const treeProfile = createParent('allProfiles', parentName)
            treeProfile.children = profiles.map(profile => createChild(treeProfile, idsProfiles, profile.id ?? '', profile.name))
            subscriber.next(treeProfile)
          }
        })
    })
  }

  createTreeEmployeeProfiles(idsProfiles: string[] | undefined): Observable<TreeNode> {
    return new Observable(subscriber => {
      this.profilesService.getAll()
        .subscribe(profiles => {
          if (profiles && profiles.length > 0) {
            const treeProfile = createParent('allProfiles', 'Funcionários da escola')
            treeProfile.children = profiles.map(profile => createChild(treeProfile, idsProfiles, profile.id ?? '', profile.name))
            subscriber.next(treeProfile)
          }
        })
    })
  }

  updateSelectedProfiles(profileNode: TreeNode, idsProfiles: string[] | undefined) {
    profileNode.children?.forEach(node => {
      const hasItem = idsProfiles?.includes(node.id) ?? false
      if (node.isChecked) {
        if (!hasItem && !node.isParent) {
          idsProfiles?.push(node.id)
        }
      }
      else {
        if (hasItem && !node.isParent) {
          const itemIndex = idsProfiles?.indexOf(node.id, 0) ?? 0
          if (itemIndex > -1)
            idsProfiles?.splice(itemIndex, 1)
        }
      }
    });

    return idsProfiles
  }

}
